import { useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Slider } from '@/components/ui/Slider';
import { useConsumables } from '@/api/queries';
import { useModalPayload, useUIStore } from '@/store/uiStore';
import { cn } from '@/lib/cn';

interface Payload {
  slotIndex: number;
  currentItemId: string | null;
  onSelect: (itemId: string | null, maxQty: number) => void;
}

export function AutobuyItemModal() {
  const open = useUIStore((s) => s.isModalOpen('autobuy-item'));
  const closeModal = useUIStore((s) => s.closeModal);
  const payload = useModalPayload<Payload>('autobuy-item');
  const { data } = useConsumables();
  const consumables = data?.consumables ?? [];
  const [selected, setSelected] = useState<string | null>(payload?.currentItemId ?? null);
  const [maxQty, setMaxQty] = useState(5);

  if (!open || !payload) return null;

  return (
    <Modal
      open={open}
      onClose={() => closeModal('autobuy-item')}
      title={`Слот ${payload.slotIndex + 1}`}
      footer={
        <div className="flex gap-2">
          <Button
            variant="ghost"
            fullWidth
            onClick={() => {
              payload.onSelect(null, 0);
              closeModal('autobuy-item');
            }}
          >
            Очистить
          </Button>
          <Button
            fullWidth
            disabled={!selected}
            onClick={() => {
              if (!selected) return;
              payload.onSelect(selected, maxQty);
              closeModal('autobuy-item');
            }}
          >
            Сохранить
          </Button>
        </div>
      }
    >
      <div className="p-4 space-y-3">
        <div className="grid grid-cols-3 gap-2">
          {consumables.map((c) => (
            <button
              key={c.item_id}
              onClick={() => setSelected(c.item_id)}
              className={cn(
                'p-2 rounded-xl border text-center transition active:scale-95',
                selected === c.item_id
                  ? 'bg-accent/15 border-accent'
                  : 'bg-bg-elevated border-white/5',
              )}
            >
              <img
                src={`/data/items/${c.icon}`}
                alt={c.name}
                className="w-12 h-12 object-contain mx-auto mb-1"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
              <div className="text-[11px] text-white">{c.name}</div>
            </button>
          ))}
        </div>
        <Slider
          value={maxQty}
          min={1}
          max={20}
          onChange={setMaxQty}
          label="Хранить до"
          suffix="шт"
        />
      </div>
    </Modal>
  );
}
